// Pixel bootstraps for Meta and LinkedIn.
// gtag (Google Tag Manager + Google Ads AW-987138275) is already loaded
// unconditionally in public/index.html, so we don't re-inject it here.
// Note: if Meta Pixel 1282942743984906 is ever also added inside GTM container
// GTM-5M2NNFC6, Chrome will log a "Duplicate Pixel ID" warning — remove one.

const META_PIXEL_ID = "1282942743984906";
const LINKEDIN_PARTNER_ID = "10129841";
const REDDIT_PIXEL_ID = "a2_gorczop03fx0";

export function loadMetaPixel() {
  if (typeof window === "undefined") return;
  if (document.getElementById("fb-pixel-script")) return;
  if (typeof window.fbq === "function") return;

  const n = function (...args) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  n.queue = [];
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  window.fbq = n;
  if (!window._fbq) window._fbq = n;

  const s = document.createElement("script");
  s.id = "fb-pixel-script";
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);

  n("init", META_PIXEL_ID);
  n("track", "PageView");
}

export function loadLinkedIn() {
  if (typeof window === "undefined") return;
  if (document.getElementById("linkedin-insight-script")) return;
  if (typeof window.lintrk === "function") return;

  window._linkedin_partner_id = LINKEDIN_PARTNER_ID;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID);

  const lintrk = function (a, b) {
    lintrk.q.push([a, b]);
  };
  lintrk.q = [];
  window.lintrk = lintrk;

  const s = document.createElement("script");
  s.id = "linkedin-insight-script";
  s.async = true;
  s.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
  document.head.appendChild(s);
}

export function loadReddit() {
  if (typeof window === "undefined") return;
  if (document.getElementById("reddit-pixel-script")) return;
  if (typeof window.rdt === "function") return;

  const rdt = function (...args) {
    if (rdt.sendEvent) {
      rdt.sendEvent.apply(rdt, args);
    } else {
      rdt.callQueue.push(args);
    }
  };
  rdt.callQueue = [];
  window.rdt = rdt;

  const s = document.createElement("script");
  s.id = "reddit-pixel-script";
  s.async = true;
  s.src = `https://www.redditstatic.com/ads/pixel.js?pixel_id=${REDDIT_PIXEL_ID}`;
  document.head.appendChild(s);

  rdt("init", REDDIT_PIXEL_ID);
  rdt("track", "PageVisit");
}

export function loadAll() {
  loadMetaPixel();
  loadLinkedIn();
  loadReddit();
}
